/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Archive } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	pushHistory: {},
};

const setPushHistory: ReduxReducer<State, State["pushHistory"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);
		if (!Number.isNaN(numericId)) {
			state.pushHistory[numericId] = data;
		}
	}

	// state.pushHistory = action.payload;
};

const archivesPushHistoryData = createSlice({
	name: Archive.ConstantOrderSlice.PUSH_HISTORY_DATA,
	initialState,
	reducers: {
		setPushHistory,
	},
});

export const archivesPushHistoryDataAction = archivesPushHistoryData.actions;
export const archivesPushHistoryDataReducer = archivesPushHistoryData.reducer;
export type archivesPushHistoryDataState = State;

export default archivesPushHistoryData;
